import { formatNumber } from "../../helpers";
import { Stat } from "./types";
import { TextPreloader } from "../../components/DataDisplay/TextPreloader";
import { StateToBadge } from "../../ui/layout/molecules/Badge/StateToBadge";
import { useAppSelector } from "../../store";
import { DIVIDED_STYLES } from "../../ui/layout/detailedPages/styles";
import { Styled } from "../../ui/layout";

type StatsUnitedProps = Styled & {
  stats: Stat[];
};

export default function StatsUnited({ stats }: StatsUnitedProps) {
  const { loading, error } = useAppSelector(
    (state) => state.dashboard.companyOverview,
  );

  return (
    <dl
      className={`${DIVIDED_STYLES} empty:hidden gap:5 grid grid-cols-1 overflow-hidden rounded-lg bg-stone-50 dark:bg-stone-900 lg:divide-x lg:divide-y-0`}
    >
      {stats.map((item) =>
        !!item.primaryStat || !!item.secondaryStat ? (
          <div key={item.name} className="flex min-h-[100px] flex-col p-4">
            <dt className="text-base font-normal text-stone-800 dark:text-stone-100">
              {item.name}
            </dt>
            <dd className="mt-1.5 flex items-baseline justify-between md:block lg:flex">
              <div className="flex items-baseline text-2xl font-semibold text-black dark:text-white">
                {error ? (
                  StateToBadge("noData")
                ) : (
                  <TextPreloader loaded={loading}>
                    {formatNumber(item.primaryStat)}
                  </TextPreloader>
                )}

                {item.secondaryStat && !error ? (
                  <span className="ml-2 text-sm font-medium text-stone-500 dark:text-stone-400">
                    <TextPreloader loaded={loading}>
                      out {formatNumber(item.secondaryStat)}
                    </TextPreloader>
                  </span>
                ) : null}
              </div>
            </dd>
          </div>
        ) : null,
      )}
    </dl>
  );
}
